import React from 'react';
import s from './index.module.scss';

import { MainScreen } from '../../components/everydoggyV2/mainScreen';
import { MainScreenPuppy } from '../../components/everydoggyV2/mainScreenPuppy';
import { MainScreenVet } from '../../components/everydoggyV2/mainScreenVet';
import { MainScreenNutrition } from '../../components/everydoggyV2/mainScreenNutrition';
import { Timer } from '../../components/everydoggyV2/timer';

type MainScreenSelectorProps = {
  vetOnboarding: boolean;
  nutritionOnboarding: boolean;
  puppyOnboarding: boolean;
  puppyBlues: boolean;
  isLastDogTrainingPaywall: boolean;
  customV52: boolean;
  tariff: string;
};

export const MainScreenSelector = ({
  vetOnboarding,
  nutritionOnboarding,
  puppyOnboarding,
  puppyBlues,
  isLastDogTrainingPaywall,
  customV52,
  tariff,
}: MainScreenSelectorProps) => {
  if (vetOnboarding) {
    return (
      <>
        <div className={s.timerWrapperPuppy}>
          <Timer tariff={tariff} />
        </div>
        <MainScreenVet />
      </>
    );
  }

  if (nutritionOnboarding) {
    return (
      <>
        <div className={s.timerWrapperPuppy}>
          <Timer tariff={tariff} />
        </div>
        <MainScreenNutrition />
      </>
    );
  }

  if (puppyOnboarding || puppyBlues) {
    return (
      <>
        <div className={s.timerWrapperPuppy}>
          <Timer tariff={tariff} />
        </div>
        <MainScreenPuppy />
      </>
    );
  }

  if (isLastDogTrainingPaywall || customV52) {
    return (
      <>
        <div key="paywall-timer" className={s.timerWrapperTop}>
          <Timer tariff={tariff} />
        </div>
        <MainScreen key="paywall-main-screen" />
      </>
    );
  }

  return (
    <>
      <MainScreen key="paywall-main-screen" />
      <div key="paywall-timer" className={s.timerWrapper}>
        <Timer tariff={tariff} />
      </div>
    </>
  );
};
